import { gql } from "@apollo/client";

export const DELETE_CONTACT_REQUESTS = gql`
  mutation deleteContactInfo($id: Int!) {
    deleteContactInfo(id: $id) {
      id
    }
  }
`;
